module.exports = "../static/media/official.7d9f59d5.png";